import React from 'react';

const UserRoundCheckIcon = () => (
  <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.66406 17.4991C1.66399 16.216 2.03417 14.9602 2.73018 13.8823C3.42619 12.8044 4.41846 11.9503 5.5879 11.4224C6.75733 10.8945 8.05426 10.7153 9.32303 10.9063C10.5918 11.0973 11.7785 11.6503 12.7407 12.4991"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33073 10.8333C10.6319 10.8333 12.4974 8.96785 12.4974 6.66667C12.4974 4.36548 10.6319 2.5 8.33073 2.5C6.02954 2.5 4.16406 4.36548 4.16406 6.66667C4.16406 8.96785 6.02954 10.8333 8.33073 10.8333Z"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3359 15.8346L15.0026 17.5013L18.3359 14.168"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserRoundCheckIcon;
